import { Injectable } from '@angular/core';
import { Headers, Http, URLSearchParams, RequestOptionsArgs } from '@angular/http';
import { environment } from '../../environments/environment';

import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class CommonService {
  private headers = new Headers({'Content-type': 'application/json'});

  constructor(private http:Http) { }

  getDias():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/dias')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getHorarios():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/horarios')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getEspecialiades():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/especialidades')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getOS():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/obras_sociales')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getCiudades():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/ciudades')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getZonas():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/zonas')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getBarrios():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/barrios')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getEstadosDelTurno():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/estados_del_turno')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getBarriosZonaCiudad():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/barrioszonaciudad')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getProfesionales():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/profesionales')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getProfesional(id):Promise<any> {
    return this.http.get(environment.apiUrl + '/get/profesionales/' + id)
      .toPromise()
      .then(response => response.json().data as any)
      .catch(this.handleError);
  }

  getEspecialiadesProfesional(id):Promise<any> {
    return this.http.get(environment.apiUrl + '/especialidadesprofesional/' + id)
      .toPromise()
      .then(response => response.json().data as any)
      .catch(this.handleError);
  }

  getOSProfesional(id):Promise<any> {
    return this.http.get(environment.apiUrl + '/osprofesional/' + id)
      .toPromise()
      .then(response => response.json().data as any)
      .catch(this.handleError);
  }
  
  getTurnosProfesional(id):Promise<any> {
    return this.http.get(environment.apiUrl + '/turnosprofesional/' + id)
      .toPromise()
      .then(response => response.json().data as any)
      .catch(this.handleError);
  }

  getLicenciasProfesional(id):Promise<any> {
    return this.http.get(environment.apiUrl + '/licenciasprofesional/' + id)
      .toPromise()
      .then(response => response.json().data as any)
      .catch(this.handleError);
  }

  getCentros():Promise<any[]> {
    return this.http.get(environment.apiUrl + '/list/centros_de_salud')
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getZonasXCiudad(idCiudad):Promise<any[]> {
    return this.http.get(environment.apiUrl + '/zonasxciudad/' + idCiudad )
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getBarriosXCiudad(idCiudad):Promise<any[]> {
    return this.http.get(environment.apiUrl + '/barriosxciudad/' + idCiudad )
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getTurnos(idProfesional):Promise<any[]> {
    return this.http.get(environment.apiUrl + '/turnos/' + idProfesional)
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getSobreturnos(idProfesional):Promise<any[]> {
    return this.http.get(environment.apiUrl + '/sobreturnos/' + idProfesional)
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getTurnosXFecha(params):Promise<any[]> {
    let search:URLSearchParams = params;
    let options:RequestOptionsArgs = {search:search};

    return this.http.get(environment.apiUrl + '/turnosxfecha', options)
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  getSobreturnosXFecha(params):Promise<any[]> {
    let search:URLSearchParams = params;
    let options:RequestOptionsArgs = {search:search};

    return this.http.get(environment.apiUrl + '/sobreturnosxfecha', options)
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  searchTurnos(params):Promise<any[]> {
    let search:URLSearchParams = params;
    let options:RequestOptionsArgs = {search:search};

    return this.http.get(environment.apiUrl + '/search/turnos', options)
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  searchTurnosP(params):Promise<any[]> {
    let search:URLSearchParams = params;
    let options:RequestOptionsArgs = {search:search};

    return this.http.get(environment.apiUrl + '/search/turnos-profesional', options)
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveZona(zona):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/save/zona', JSON.stringify(zona), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveBarrio(barrio):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/save/barrio', JSON.stringify(barrio), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveOS(os):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/save/os', JSON.stringify(os), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveCentro(centro):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/save/centro', JSON.stringify(centro), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveProfesional(profesional):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/save/profesional', JSON.stringify(profesional), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveEspecialidadXProfesional(idProfesional, idEspecialidad):Promise<any[]> {
    var data = {
      idProfesional:idProfesional,
      idEspecialidad:idEspecialidad
    };

    return this.http.post(environment.apiUrl + '/addespecialidadxprofesional', JSON.stringify(data), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveOsXProfesional(idProfesional, idOs):Promise<any[]> {
    var data = {
      idProfesional:idProfesional,
      idOs:idOs
    };

    return this.http.post(environment.apiUrl + '/addosxprofesional', JSON.stringify(data), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveLicenciaProfesional(licencia):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/addlicenciaxprofesional', JSON.stringify(licencia), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveTurnoProfesional(turno):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/addturnoxprofesional', JSON.stringify(turno), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveTurno(turno):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/save/turno', JSON.stringify(turno), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  saveSobreTurno(turno):Promise<any[]> {
    return this.http.post(environment.apiUrl + '/save/sobreturno', JSON.stringify(turno), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  rescheduleTurno(reschData):Promise<any[]> {
    return this.http.put(environment.apiUrl + '/update/schedule-turno', JSON.stringify(reschData), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  updateEstadoTurno(updateData):Promise<any[]> {
    return this.http.put(environment.apiUrl + '/update/estadoturno', JSON.stringify(updateData), {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  bajaTurnoProfesional(idTurno):Promise<any[]> {
    return this.http.put(environment.apiUrl + '/baja/turnoprofesional/' + idTurno, {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  removeLicencia(idLicencia):Promise<any> {
    return this.http.post(environment.apiUrl + '/removelicencia/' + idLicencia, {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  removeTurno(idTurno):Promise<any> {
    return this.http.post(environment.apiUrl + '/removeturno/' + idTurno, {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  removeSobreturno(idSobreturno):Promise<any> {
    return this.http.post(environment.apiUrl + '/removesobreturno/' + idSobreturno, {headers: this.headers})
      .toPromise()
      .then(response => response.json().data as any[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/services/common.service.ts